import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "documentevent"
    }}>{`DocumentEvent`}</h1>
    <p>{`A document event.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_NEW`}</strong>{` = beforeNew`}</p>
      <p parentName="blockquote">{`Dispatched before a Document is created. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_NEW`}</strong>{` = afterNew`}</p>
      <p parentName="blockquote">{`Dispatched after a Document is created. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_OPEN`}</strong>{` = beforeOpen`}</p>
      <p parentName="blockquote">{`Dispatched before a Document is opened. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_OPEN`}</strong>{` = afterOpen`}</p>
      <p parentName="blockquote">{`Dispatched after a Document is opened. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_SAVE`}</strong>{` = beforeSave`}</p>
      <p parentName="blockquote">{`Dispatched before a Document is saved. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_SAVE`}</strong>{` = afterSave`}</p>
      <p parentName="blockquote">{`Dispatched after a Document is saved. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_SAVE_AS`}</strong>{` = beforeSaveAs`}</p>
      <p parentName="blockquote">{`Dispatched before a Document is saved under a new name. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_SAVE_AS`}</strong>{` = afterSaveAs`}</p>
      <p parentName="blockquote">{`Dispatched after a Document is saved under a new name. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_SAVE_A_COPY`}</strong>{` = beforeSaveACopy`}</p>
      <p parentName="blockquote">{`Dispatched before a copy of a Document is saved. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_SAVE_A_COPY`}</strong>{` = afterSaveACopy`}</p>
      <p parentName="blockquote">{`Dispatched after a copy of a Document is saved. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_REVERT`}</strong>{` = beforeRevert`}</p>
      <p parentName="blockquote">{`Dispatched before a Document is reverted. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_REVERT`}</strong>{` = afterRevert`}</p>
      <p parentName="blockquote">{`Dispatched after a Document is reverted. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_CLOSE`}</strong>{` = beforeClose`}</p>
      <p parentName="blockquote">{`Dispatched before a Document is closed. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_CLOSE`}</strong>{` = afterClose`}</p>
      <p parentName="blockquote">{`Dispatched after a Document is closed. This event bubbles. This event is not cancelable.`}</p>
    </blockquote>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`File `}<strong parentName="p">{`fullName`}</strong>{` `}</p>
      <p parentName="blockquote">{`The full path to the DocumentEvent, including the name of the DocumentEvent.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`eventType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of the event.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`target`}</strong>{` `}</p>
      <p parentName="blockquote">{`The target of the event.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`currentTarget`}</strong>{` `}</p>
      <p parentName="blockquote">{`The current propagation target of the event.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventPhases `}<strong parentName="p">{`eventPhase`}</strong>{` `}</p>
      <p parentName="blockquote">{`The current propagation phase of the event.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`bubbles`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the event supports the bubbling phase of propagation.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`cancelable`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the default behavior of the event on its target can be canceled.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Date `}<strong parentName="p">{`timeStamp`}</strong>{` `}</p>
      <p parentName="blockquote">{`The time the event was initialized.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`propagationStopped`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, propagation of the event beyond the current target has been stopped.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`defaultPrevented`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the default behavior of the event on its target has been canceled.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`id`}</strong>{` `}</p>
      <p parentName="blockquote">{`The unique ID of the DocumentEvent.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the DocumentEvent (a Application or Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`index`}</strong>{` `}</p>
      <p parentName="blockquote">{`The index of the DocumentEvent within its containing object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`UserInteractionLevels `}<strong parentName="p">{`userInteractionLevel`}</strong>{` `}</p>
      <p parentName="blockquote">{`Controls the display of dialogs and alerts during script processing.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`stopPropagation`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Stops propagation of the event beyond the current target.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`preventDefault`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Cancels the default behavior of the event on its target.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the DocumentEvent.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`DocumentEvent `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      